<template>

  <div>
    
    <!--  css -->
    <!-- <link rel="stylesheet" href="http://ux.gluo.mx/ux/projects/unitec/prospeccion/clientlib-site/site.css"
    type="text/css">-->
    <!--<link rel="stylesheet" href="https://dev-unitec.gluo.mx/etc.clientlibs/unitec/clientlibs/clientlib-site.css"
    type="text/css">-->
    <!--<link href="http://ux.gluo.mx/ux/projects/unitec/prospeccion/clientlib-site/site.css" rel="stylesheet">-->
    <!--  css -->
             
    
    <!--Comienzo del componente web contenedor de los componentes para alumno,padre, docente-->
    <div>
    <component :is="seleccionado" :correo="correo"></component> 
    <!--Componenten del alumno -->
    <!--<alumno-component v-model="newvalue"></alumno-component>-->

    <!--Componenten del docente -->
    <!--<docente-component></docente-component>-->

     <!--Componenten del tutor-->
    <!--<tutor-component></tutor-component>-->

  </div>
  </div>
  <!--fin del componente web contenedor de los componentes para alumno,padre, docente-->
</template>

<!--  js -->
<script src="https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/vue@2.5.16/dist/vue.js"></script>
<!--  js -->

<style scoped>

</style>
<script>
//Componentes del alumno
import AlumnoComponent from './components/alumno/AlumnoformComponent'
import RecoverComponent from './components/alumno/RecoverComponent'
import AddpassComponent from './components/alumno/AddpassComponent'
import AddpassnewComponent from './components/alumno/AddpassnewComponent'
export default {
  name: 'App',
  props:['typeusuario','typeschool','idschool'],
  components: {
     AlumnoComponent,
     RecoverComponent,
     AddpassComponent,
     AddpassnewComponent,
  },
  data(){
        return {
            seleccionado: this.getTpuser(),
            correo: this.getIdschool(),
        };
    },

    methods:{
      getIdschool(){
      var url_string = window.location.href; 
      var url = new URL(url_string);
      var idEscuela = url.searchParams.get("correo");
      return idEscuela;
      //console.log("idEscuela "+idEscuela);  
    },
    getTpuser(){
        var url_string = window.location.pathname; 
        console.log(url_string);
        if(url_string == "/login"){
          var nameComponent = "AlumnoComponent";
       }
       if(url_string == "/recuperar-password") {
          var nameComponent = "AddpassComponent";
        }
      return nameComponent;
    }
    },
}
</script>